import Destacados from "./Destacados";

export default Destacados;
